import axios from 'axios';
import API_URL from '../config/api';

// Single axios instance for the admin panel: attaches the token and sends the
// user back to login whenever the server says the session is no longer valid.
const adminApi = axios.create({ baseURL: `${API_URL}/api` });

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (!window.location.pathname.startsWith('/admin/login')) {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  }
);

// Downloads a CSV through the same auth-aware instance, so the export endpoint
// stays behind the token rather than being opened as a bare URL.
export const downloadCsv = async (path, params, filename) => {
  const response = await adminApi.get(path, { params, responseType: 'blob' });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const readableError = (error, fallback = 'Something went wrong. Please try again.') => {
  if (error?.response?.data?.errors?.length) {
    return error.response.data.errors.map((e) => e.msg).join(', ');
  }
  return error?.response?.data?.message || error?.message || fallback;
};

export default adminApi;
